import React from 'react'
import { Box, Typography } from '@material-ui/core'
import { SearchRounded } from '@material-ui/icons'
import { Helmet } from 'react-helmet'

export default function NotFoundScreen() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      height="100vh"
      bgcolor="grey.900"
      color="white"
    >
      <Helmet>
        <meta charSet="utf-8" />
        <title>404 Page not found</title>
      </Helmet>
      <Box fontSize="5rem">
        <SearchRounded fontSize="inherit" />
      </Box>
      <Box>
        <Typography variant="h5">404</Typography>
      </Box>
      <Box>
        <Typography>Page not found.</Typography>
      </Box>
    </Box>
  )
}
